module.exports = __webpack_public_path__ + "static/media/man-typing.01c2563a.png";